import ApiRequest from "../../utils/apiRequest";
import { API_URL } from "../../configs/_api";


const useSysSettingActions = () => {
  
  async function fetchSysSetting() {
  try {
    const url = `${API_URL.SysSetting}`;
    const res = await ApiRequest.get(url);
    let data = res.data.payload.data;
    if (!Array.isArray(data)) {
      data = [data]; 
    }
    return data;  
  } catch(err) {
    console.error(err);
    return null; 
  }
}


  async function updateSysSetting(SysSetting) {
    let edit_SysSetting_url = API_URL.SysSetting + "/update";

    try {
      const res = await ApiRequest.post(edit_SysSetting_url, SysSetting, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      const editSysSetting = res.data;
      return editSysSetting;
    } catch (err) {
      const errMsg =
        err.response?.data.errors?.message ?? `${err.message}. Fail to Edit!`;
      return Promise.reject(errMsg);
    }
  }


    return {
        fetchSysSetting,
        updateSysSetting
    }
}

export default useSysSettingActions;
